import { Route } from '@angular/router';

import { TaskTabListsResolver, TaskFieldDefsResolver } from './tasks.resolvers';
import { LegacyTasksTabComponent } from './tasks.component';
import { TasksSettingsComponent } from '../tasks/settings/settings.component';
import { TaskListComponent } from './list/list.component';
import { LegacyTaskDetailsComponent } from './details/details.component';
import { CanActivateTaskSettings, CanDeactivateTasksDetails } from './tasks.guards';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from '../../../modules/projects/projects.resolvers';
import { RelatedToType } from 'app/shared/enums';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';

export const tasksRoutes: Route[] = [
  {
    path: '',
    component: LegacyTasksTabComponent,
    resolve: {
      taskLists: TaskTabListsResolver,
      taskFieldDefs: TaskFieldDefsResolver,
    },
    data: {
      relatedToType: RelatedToType.Task,
    },
    children: [
      {
        path: 'settings',
        component: TasksSettingsComponent,
        canActivate: [CanActivateTaskSettings],
      },
      {
        path: ':task_list_id',
        component: TaskListComponent,
        data: {
          optionsToLoadEnabled: true,
        },
        resolve: {
          fieldDefs: ProjectsFieldDefsResolver,
          options: ProjectDataResolver,
        },
        children: [
          {
            path: ':task_id',
            component: LegacyTaskDetailsComponent,
            resolve: {
              fieldDefs: ProjectsFieldDefsResolver,
            },
            canDeactivate: [CanDeactivateTasksDetails],
          },
        ],
      },
    ],
  },
];
